export default __webpack_public_path__ + "static/media/poke-css.11fb813f.rar";